var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"tableTitle":_vm.tableTitle,"form":_vm.form,"search-url":_vm.url,"pageFooter":false,"searchTime":false,"searchBtn":false,"setting":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }